import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import ClientsSection from './components/ClientsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ComplianceSection from './components/ComplianceSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <TestimonialsSection />
        <ServicesSection />
        <ProcessSection />
        <ClientsSection />
        <ComplianceSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;